export const CREATE_OWNER_YIELD_MANAGER_SSP = 'CREATE_OWNER_YIELD_MANAGER_SSP';
export const DELETE_OWNER_YIELD_MANAGER_SSP = 'DELETE_OWNER_YIELD_MANAGER_SSP';
export const SAVE_OWNER_YIELD_MANAGER_SSP = 'SAVE_OWNER_YIELD_MANAGER_SSP';
export const UPDATE_OWNER_YIELD_MANAGER_SSP = 'UPDATE_OWNER_YIELD_MANAGER_SSP';
export const UPDATE_OWNER_YIELD_MANAGER_SSPS_LIST = 'UPDATE_OWNER_YIELD_MANAGER_SSPS_LIST';
